<template>
  <div>
    <view-table
        ref="viewTable"
        :limits="limits"
        :filter="filter"
        :columns-property="columnsProperty"
        module="basic"
        url="outStockProductions"
        @reset="resetHandle"
        @delete="deleteHandle"
        @select="selectHandle"
        @addOrEdit="addEditHandle">
      <template slot="otherBtn">
        <el-button v-if="submitAuth" type="primary" :disabled="!selection.length" @click="submit"> 提交</el-button>
        <el-button v-if="cancelAuth" type="primary" :disabled="!selection.length" @click="repeal"> 撤销</el-button>
        <!--        <el-button v-if="printAuth" type="primary" :disabled="!selection.length" @click="printOutStockOrder()"> 打印领料单 </el-button>-->
        <el-button v-if="printAuth1" type="primary" :disabled="!selection.length" @click="printOutStockOrder1()">
          打印
        </el-button>
        <el-button v-if="delAllAuth" type="danger" :disabled="!selection.length" @click="deleteBatch"> 批量删除</el-button>
      </template>
      <template slot="adSearch">
        <el-form :inline="true" :model="filter" label-width="90px" @keyup.enter.native="loadData(1)">
          <el-form-item label="领料单号">
            <el-input v-model.trim="filter.billNo" placeholder="请输入领料单号" clearable/>
          </el-form-item>
          <el-form-item label="领料状态">
            <el-select v-model="filter.status" clearable placeholder="请选择领料状态">
              <el-option label="全部" :value="-1"/>
              <el-option label="已开领料单" :value="0"/>
              <el-option label="待仓库配料" :value="1"/>
              <el-option label="待车间确认" :value="3"/>
              <el-option label="已完成" :value="2"/>
            </el-select>
          </el-form-item>
          <!--          <el-form-item label="物料类型">-->
          <!--            <el-select v-model="filter.materialTypeId" placeholder="请选择" clearable>-->
          <!--              <el-option-->
          <!--                  v-for="item in materialTypeList"-->
          <!--                  :key="item.pkid"-->
          <!--                  :label="item.materialTypeName"-->
          <!--                  :value="item.pkid"/>-->
          <!--            </el-select>-->
          <!--          </el-form-item>-->
          <el-form-item label="物料类型">
            <el-select
                v-model="materialTypeList"
                :popper-append-to-body="false"
                class="biddingStageSty"
                multiple
                clearable
                placeholder="请选择"
                @change="handleSelectMaterialType">
              <el-option
                  v-for="item in materialTypeOptions"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"/>
            </el-select>
          </el-form-item>
          <el-form-item label="关联单据">
            <el-input v-model.trim="filter.relBillNo" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="生产任务单">
            <el-input v-model.trim="filter.productionOrderNo" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="物料编号">
            <el-input v-model.trim="filter.materialNo" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="物料名称">
            <el-input v-model.trim="filter.materialName" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="规格型号">
            <el-input v-model.trim="filter.specification" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="明细物料编号">
            <el-input v-model.trim="filter.subMaterialNo" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="明细物料名称">
            <el-input v-model.trim="filter.subMaterialName" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="明细规格型号">
            <el-input v-model.trim="filter.subSpecification" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="要求日期">
            <el-date-picker
                v-model="requireDateRange"
                type="daterange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                value-format="yyyy-MM-dd"
                @change="dateRangeChange('requireDateRange', 'requireDateBegin', 'requireDateEnd')"/>
          </el-form-item>
          <el-form-item label="制单日期">
            <el-date-picker
                v-model="createDateRange"
                type="daterange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                value-format="yyyy-MM-dd"
                @change="dateRangeChange('createDateRange', 'createTimeBegin', 'createTimeEnd')"/>
          </el-form-item>
          <el-form-item label="制单人">
            <el-input v-model="filter.creatorName" type="textarea" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="配料人">
            <el-input v-model="filter.stockUserName" type="textarea" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="完成人">
            <el-input v-model="filter.finishUserName" type="textarea" placeholder="请输入" clearable/>
          </el-form-item>
        </el-form>
      </template>
    </view-table>
    <production-picking-edit ref="editPage" @save-success="loadData(1)"/>
    <print-production-picking ref="printOutStockOrder"/>
    <print-production-picking1 ref="printOutStockOrder1"/>
  </div>
</template>

<script>
  import ViewTable from "@/components/ViewTable.vue";
  import ProductionPickingEdit from "./ProductionPickingEdit.vue";
  import PrintProductionPicking from "./PrintProductionPicking.vue";
  import PrintProductionPicking1 from "./PrintProductionPicking1.vue";

  export default {
    name: "ProductionPickingList",
    components: {ViewTable, ProductionPickingEdit, PrintProductionPicking, PrintProductionPicking1},
    data() {
      return {
        ids: [],
        selection: [],
        requireDateRange: [],
        createDateRange: [],
        materialTypeList: [],
        materialTypeOptions: [],
        limits: {
          addAuth: this.$auth(34),
          delAuth: this.$auth(41),
          editAuth: this.$auth(39),
        },
        detailAuth: this.$auth(40),
        delAllAuth: this.$auth(38),
        printAuth: this.$auth(37),
        printAuth1: this.$auth(406),
        submitAuth: this.$auth(35),
        cancelAuth: this.$auth(36),
        searchShow: false,
        OutStorageDate: "",
        createDate: "",
        filter: {
          billNo: "",
          outStockType: 2,
          status: "",
          relBillNo: "",
          requireDateBegin: "",
          requireDateEnd: "",
          createTimeBegin: "",
          createTimeEnd: "",
          creatorName: "",
          stockUserName: "",
          finishUserName: "",
          materialTypeId: "",
          materialTypeIds: "",
          note: "",
          productionOrderNo: "",
          materialNo: "",
          materialName: "",
          specification: "",
          subMaterialNo: "",
          subMaterialName: "",
          subSpecification: "",
        },
        columnsProperty: [
          {
            key: "billNo",
            align: "center",
            width: 140,
            render: (h, params) => {
              return h(
                "span",
                {
                  style: {
                    color: "#2d8cf0",
                    cursor: "pointer",
                  },
                  on: {
                    click: () => {
                      if (this.detailAuth) {
                        this.$refs.editPage.open(params.row, true);
                      }
                    },
                  },
                },
                params.row.billNo,
              );
            },
          },
          {
            key: "outStockTypeName",
            align: "center",
            width: 120,
          },
          {
            key: "statusName",
            align: "center",
            width: 120,
          },
          {
            key: "action",
            align: "center",
            width: 140,
            slot: "action",
            fixed: "right",
          },
        ],
      };
    },

    watch: {
      "filter.requireDateBegin": {
        handler(newVal) {
          if (newVal) {
            this.requireDateRange = [];
            this.requireDateRange.push(this.filter.requireDateBegin);
            this.requireDateRange.push(this.filter.requireDateEnd);
          }
        },
      },
      "filter.createTimeBegin": {
        handler(newVal) {
          if (newVal) {
            this.createDateRange = [];
            this.createDateRange.push(this.filter.createTimeBegin);
            this.createDateRange.push(this.filter.createTimeEnd);
          }
        },
      },
      "filter.materialTypeIds": {
        handler(val) {
          if (val) {
            this.materialTypeList = [];
            this.materialTypeOptions.map(item => {
              val.split(",").forEach((s) => {
                if (parseInt(s) === parseInt(item.value)) {
                  this.materialTypeList.push(item.value);
                }
              });
            });
          }
        },
      },
    },
    created() {
      this.getMaterialTypeList();
    },
    methods: {
      // 查询
      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },
      dateRangeChange(timeRange, timeStart, timeEnd) {
        if (this[timeRange]) {
          this.filter[timeStart] = this[timeRange][0];
          this.filter[timeEnd] = this[timeRange][1];
        } else {
          this.filter[timeStart] = "";
          this.filter[timeEnd] = "";
        }
      },

      getMaterialTypeList() {
        this.materialTypeOptions = [];
        this.$http.get("basic", "materialTypes/getAllList").then((res) => {
          if (res.success) {
            res.data.forEach((item) => {
              let temp = {"name": item.materialTypeName, "value": item.pkid};
              this.materialTypeOptions.push(temp);
            });
          }
        });
      },
      handleSelectMaterialType(value) {
        if (value.length) {
          // this.materialTypeList = value;
          this.filter.materialTypeIds = value.join(",");
        } else {
          // this.materialTypeList = [];
          this.filter.materialTypeIds = "";
        }
      },
      addEditHandle(row) {
        this.$refs.editPage.open(row);
      },

      selectHandle(selection) {
        this.ids = [];
        this.selection = selection;
        this.selection.forEach((item) => {
          this.ids.push(item.pkid);
        });
      },

      // 提交
      submit() {
        const arr = this.selection.filter((item) => item.status !== 0);
        if (arr.length) {
          this.$confirm("请选择未提交的订单", "错误", {
            type: "error",
            showCancelButton: false,
          });
        } else {
          this.$confirm("确定提交吗?", "提示", {type: "warning"}).then(() => {
            this.$http.post("basic", "outStockBills/submit", this.ids).then(() => {
              this.loadData(1);
              this.$message.success("提交成功");
              this.selection = [];
            });
          });
        }
      },

      // 撤销
      repeal() {
        const arr = this.selection.filter((item) => item.status !== 1 && item.status !== 3);
        if (arr.length) {
          this.$confirm("请选择待仓库配料或待车间确认状态的订单", "错误", {
            type: "error",
            showCancelButton: false,
          });
        } else {
          this.$confirm("确定撤销吗?", "提示", {type: "warning"}).then(() => {
            this.$http.post("basic", "outStockProductions/cancel", this.ids).then(() => {
              this.loadData(1);
              this.$message.success("撤销成功");
              this.selection = [];
            });
          });
        }
      },

      // 打印领料单
      printOutStockOrder() {
        const arr = this.selection.filter((item) => item.status == 0);
        if (arr.length) {
          this.$confirm("请选择已提交或已出库的订单", "错误", {
            type: "error",
            showCancelButton: false,
          });
          return;
        }
        this.$refs.printOutStockOrder.open(this.ids);
      },

      // 打印领料单
      printOutStockOrder1() {
        const arr = this.selection.filter((item) => item.status == 0);
        if (arr.length) {
          this.$confirm("请选择已提交或已出库的订单", "错误", {
            type: "error",
            showCancelButton: false,
          });
          return;
        }
        this.$refs.printOutStockOrder1.open(this.ids);
      },

      // 单个删除
      deleteHandle(row) {
        this.$http.delete("basic", "outStockProductions", row.pkid).then((resp) => {
          if (resp.success) {
            this.loadData(1);
            this.$message.success("删除成功");
            this.selection = [];
          }
        });
      },

      // 批量删除
      deleteBatch() {
        const arr = this.selection.filter((item) => item.status !== 0);
        if (arr.length) {
          this.$confirm("请选择已开领料单状态的订单", "错误", {
            type: "error",
            showCancelButton: false,
          });
          return;
        }
        this.$confirm("确定删除吗?", "提示", {type: "warning"}).then(() => {
          this.$http.post("basic", "outStockProductions/deleteBatch", this.ids).then((resp) => {
            if (resp.success) {
              this.loadData(1);
              this.$message.success("删除成功");
              this.selection = [];
            }
          });
        });
      },

      resetHandle(filter) {
        this.filter = Object.assign(this.filter, filter);
      },

      otherAuth(row) {
        if (row.status === 1 || row.status === 2 || row.status === 3) {
          return {
            editAuth: true,
            delAuth: true,
          };
        } else {
          return {
            editAuth: false,
            delAuth: false,
          };
        }
      },
    },
  };
</script>
